var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.845 3.77652H17.0032C16.8587 3.77652 16.6795 3.68098 16.5398 3.5303L15.2903 1.51432C15.2706 1.48232 15.2485 1.45187 15.2244 1.42322C14.7928 0.908636 14.2095 0.625 13.5833 0.625H9.1519C8.52573 0.625 7.94242 0.908636 7.51084 1.42322C7.48667 1.45187 7.46461 1.48232 7.44485 1.51432L6.19539 3.53326C6.08846 3.65242 5.93818 3.77947 5.78019 3.77947V3.38553C5.78019 3.17657 5.699 2.97617 5.55447 2.82842C5.40994 2.68066 5.21391 2.59765 5.00952 2.59765H3.8535C3.6491 2.59765 3.45308 2.68066 3.30855 2.82842C3.16402 2.97617 3.08282 3.17657 3.08282 3.38553V3.77947H2.89015C2.27716 3.78012 1.68946 4.02936 1.25601 4.47248C0.822555 4.91561 0.578763 5.51643 0.578125 6.14311V15.5947C0.578763 16.2214 0.822555 16.8222 1.25601 17.2653C1.68946 17.7084 2.27716 17.9577 2.89015 17.9583H19.845C20.458 17.9577 21.0457 17.7084 21.4792 17.2653C21.9126 16.8222 22.1564 16.2214 22.1571 15.5947V6.14015C22.1564 5.51348 21.9126 4.91265 21.4792 4.46953C21.0457 4.0264 20.458 3.77717 19.845 3.77652ZM11.3676 14.8068C10.453 14.8068 9.55903 14.5296 8.79861 14.0101C8.03818 13.4907 7.44551 12.7524 7.09552 11.8886C6.74554 11.0248 6.65397 10.0743 6.83239 9.1573C7.01081 8.2403 7.45121 7.39798 8.09789 6.73686C8.74458 6.07574 9.56851 5.62551 10.4655 5.44311C11.3625 5.2607 12.2922 5.35432 13.1371 5.71212C13.9821 6.06991 14.7043 6.67582 15.2124 7.45321C15.7205 8.23061 15.9917 9.14458 15.9917 10.0795C15.9903 11.3329 15.5026 12.5344 14.6358 13.4206C13.7689 14.3069 12.5935 14.8054 11.3676 14.8068V14.8068Z",
    fill: "url(#paint0_linear_247_17)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_247_17",
    x1: 11.5493,
    y1: 21.6511,
    x2: 35.0101,
    y2: -6.97927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon-camera.e4c10e93.svg";
export { ForwardRef as ReactComponent };